<template>
  <div class="controls__upper">
    <div class="controls__container">
      <div v-if="title" class="overlay__title">
        <span class="overlay__title__text" data-overlay-prevent-close v-html="title"></span>
      </div>
      <div class="controls__close">
        <a class="controls__link" data-gtm="carousel overlay / close x" data-overlay-close-button
          aria-label="Close overlay" href="javascript:void(0)" role="button" @click="$emit('close', $event)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="controls__link__svg--close">
            <path d="M1.5 22.5l21-21m-21 0l21 21" fill="none" vector-effect="non-scaling-stroke"></path>
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true }
  },
};
</script>
